import { Icon } from '../../index';
import * as React from 'react';

type IconProps = React.ComponentProps<typeof Icon>;
const SeasonIcon = ({
  value,
  size = 'lg',
}: {
  value: string | number;
  size?: IconProps['size'];
}) => {
  const SEASON_ICONS: Record<number | string, React.ReactNode> = {
    1: <Icon icon='sun' color='orange' size={size} />,
    'Ete': <Icon icon='sun' color='orange' size={size} />,

    2: <Icon icon='flake' size={size} />,
    'Hiver': <Icon icon='flake' size={size} />,

    3: <Icon icon='four-season' size={size} />,
    '4S': <Icon icon='four-season' size={size} />,
  };

  return <>{SEASON_ICONS[value]}</>;
};

export default SeasonIcon;
